import { Logo } from "@/components/ui/logo";
import { LoginForm } from "@/features/auth/components/LoginForm";
import { useAuthStore } from "@/features/auth/store/authStore";
import { Navigate } from "react-router-dom";

export default function LoginPage() {
    const { isAuthenticated } = useAuthStore();
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }
    return (
        <div className="min-h-screen flex flex-col bg-background">
            {/* Main content */}
            <div className="flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8">
                <div className="w-full max-w-md space-y-8">
                    {/* Logo and header */}
                    <div className="text-center flex flex-col items-center gap-6">
                        <Logo size="lg" className="justify-center" />
                        <div>
                        <h1 className="text-2xl sm:text-3xl font-bold text-foreground">
                            Welcome back
                        </h1>
                        <p className="mt-2 text-muted-foreground">
                            Sign in to access your tax documents
                        </p>
                        </div>
                    </div>

                    {/* Login form */}
                    <LoginForm />
                </div>
            </div>

            {/* Footer */}
            <footer className="py-6 text-center">
                <p className="text-sm text-muted-foreground">
                    © {new Date().getFullYear()} My Professional Tax. All rights
                    reserved.
                </p>
            </footer>
        </div>
    );
}
